import Vue from 'vue'
// import MintUI from 'mint-ui'
import router from './router.js'
// import 'mint-ui/lib/style.css'
import App from './app.vue'
import store from './store' // 引入store
import 'lib-flexible/flexible.js'
import 'normalize.css/normalize.css'
import '../../styles/index.scss'
import { IsPC } from '../../utils/index.js'
Vue.prototype.$IsPC = IsPC
const vue = new Vue({
	el: '#app',
	router,
	store,
	render: (h) => h(App),
})
